import { TABLE_ATTRIBUTE_TYPES } from "../../settings/constants/types";

export const OperationKeyValues = (valType) => {
    switch (valType.toUpperCase()) {
        case TABLE_ATTRIBUTE_TYPES.INT: case TABLE_ATTRIBUTE_TYPES.DOUBLE: case TABLE_ATTRIBUTE_TYPES.LONG:
            return ([
                { label: "Is Equal to", value: "EQUAL_TO" },
                { label: "Is Not Equal to", value: "NOT_EQUAL" },
                { label: "Is Greater than", value: "GREATER_THEN" },
                { label: "Is Less than", value: "LESS_THEN" },
                { label: "Is Greater than Equal", value: "GREATER_THEN_EQUAL" },
                { label: "Is Less than Equal", value: "LESS_THEN_EQUAL" },
            ]);

        case TABLE_ATTRIBUTE_TYPES.STRING: case TABLE_ATTRIBUTE_TYPES.UUID: case TABLE_ATTRIBUTE_TYPES.JSON_LIST: case TABLE_ATTRIBUTE_TYPES.COLLECTION_OBJECT :
            return ([
                { label: "Contains", value: "MATCH_TO" },
                { label: "Does Not Contain", value: "NOT_MATCH_TO" },
                { label: "Start With", value: "MATCH_START" },
                { label: "End With", value: "MATCH_END" },
                { label: "Equal", value: "EQUAL_TO" },
                { label: "Does Not Equal", value: "NOT_EQUAL" },
            ]);

        case TABLE_ATTRIBUTE_TYPES.BOOLEAN:

            break;

        case TABLE_ATTRIBUTE_TYPES.ENUM:

            break;
        case TABLE_ATTRIBUTE_TYPES.DATE: case TABLE_ATTRIBUTE_TYPES.DATETIME:
            return ([
                { label: "Today", value: "EQUAL_TO" },
                { label: "Yesterday", value: "EQUAL_TO" },
                { label: "This Week", value: "IS_BETWEEN" },
                { label: "Last Week", value: "IS_BETWEEN" },
                { label: "Last Two Weeks", value: "IS_BETWEEN" },
                { label: "This Month", value: "IS_BETWEEN" },
                { label: "Last Month", value: "IS_BETWEEN" },
                { label: "Last Two Month", value: "IS_BETWEEN" },
                { label: "Before", value: "LESS_THEN" },
                { label: "After", value: "GREATER_THEN" },
                // { label: "Specific Date", value: "EQUAL_TO" },
                { label: "Custom", value: "IS_BETWEEN" },
            ]);
            break;

        default:
            break;
    }
}